import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { TenderingService } from 'src/app/services/tendering/tendering.service';
import { Enquiryheader } from 'src/app/model/enquiryheader.model';
import { NgForm, FormsModule, FormGroup, FormBuilder } from '@angular/forms';
import { Enquiryline } from 'src/app/model/enquiryline.model';
import { UserService } from 'src/app/services/user/user.service';
import { DataSharingService } from 'src/app/auth/data-sharing.service';
import { isNullOrUndefined } from 'util';
import { EnlistmentService } from 'src/app/services/enlistment/enlistment.service';

@Component({
  selector: 'app-techpricevendor',
  templateUrl: './techpricevendor.component.html',
  styleUrls: ['./techpricevendor.component.css']
})
export class TechpricevendorComponent implements OnInit {

  stepno: string;
  enquiryData: any;
  enquiryHeader: Enquiryheader;
  isUserAdmin: boolean = false;

  //data: Enquiryline[];
  data: Enquiryline[];

  totalQuoteValue: any = 0;
  tempquantity: any;
  temprate: any;

  form: FormGroup;
  vendorDocs: any;

  constructor(private router: Router, private route: ActivatedRoute,
    private tenderingServices: TenderingService, private userService: UserService,
    private dataSharingService: DataSharingService, private fb: FormBuilder,
    private enlistmentServices: EnlistmentService) {
    this.stepno = this.route.snapshot.params.enquiryid;

    this.userService.isUserAdmin.subscribe(
      value => {
        this.isUserAdmin = value;
        //alert(this.isUserAdmin);
      });

    this.form = this.fb.group({
      avatar: null
    });

  }

  ngOnInit() {
    this.getEnquiryById();
   
  }

  getEnquiryById() {
    this.tenderingServices.GetEnquiryQuotesById(this.stepno).subscribe(
      (datas: any) => {
        this.enquiryData = datas;
        this.enquiryHeader = this.enquiryData;
        this.getVendorDocs();
        console.log(this.enquiryHeader);
        this.data = this.enquiryHeader.enquiryLine;

        for (var i = 0; i < this.data.length; i++) {
          // var unirate = this.data[i].unitRate;
          // unirate = unirate.replace(/\,/g,'');
          // this.data[i].unitRate = unirate;

          var quantty = this.data[i].quantity;
          quantty = quantty.replace(/\,/g, '');
          this.data[i].quantity = quantty;
        }

        console.log(this.data);

      }
    )
    
  }

  calculateTotal(quantity, unitrate) {
    this.totalQuoteValue = 0;
    this.tempquantity = 0;
    this.temprate = 0;
    //console.log(quantity, unitrate);
    //console.log(this.data);
    //this.totalQuoteValue = this.totalQuoteValue + quantity * unitrate;
    //this.enquiryHeader.grandTotal = this.totalQuoteValue.toString();
    //console.log(this.totalQuoteValue);
    debugger;
    for (var i = 0; i < this.data.length; i++) {
      this.tempquantity = parseFloat(this.data[i].quantity);
      if (isNullOrUndefined(this.tempquantity) || isNaN(this.tempquantity)) {
        this.tempquantity = 0;
      }
      this.temprate = parseFloat(this.data[i].unitRate);
      if (isNullOrUndefined(this.temprate) || isNaN(this.temprate)) {
        this.temprate = 0;
      }

      var temp = this.tempquantity * this.temprate;
      this.totalQuoteValue = this.totalQuoteValue + temp;
    }
    this.enquiryHeader.grandTotal = this.totalQuoteValue.toString();


    if (!isNullOrUndefined(this.enquiryHeader.freightTransport)) {
      var gtotal = parseFloat(this.totalQuoteValue) + parseFloat(this.enquiryHeader.freightTransport);
      this.enquiryHeader.grandTotal = gtotal.toString();
    }


    this.enquiryHeader.totalBasicAmount = this.totalQuoteValue.toString();
    console.log(this.totalQuoteValue);
  }

  calculateFreight(freightAmount) {
    var gtotal = parseFloat(this.enquiryHeader.totalBasicAmount) + parseFloat(freightAmount);
    this.enquiryHeader.grandTotal = gtotal.toString();
  }

  SubmitTechPriceQuoteForm(form: NgForm) {

    this.enquiryHeader.enquiryLine = this.data;
    this.enquiryHeader.quoteType = "both";
    //this.enquiryHeader.id = 0;


    if (this.isUserAdmin) {
      this.enquiryHeader.isQuoteApproved = true;
    }

    for (var i = 0; i < this.enquiryHeader.enquiryLine.length; i++) {
      this.enquiryHeader.enquiryLine[i].quoteType = "both";
      this.enquiryHeader.enquiryLine[i].vendorNo = this.enquiryHeader.vendorNo;
      this.enquiryHeader.enquiryLine[i].id = 0;
    }

    //console.log(this.enquiryHeader);
    this.tenderingServices.SubmitTechPriceQuote(this.enquiryHeader).subscribe(
      (data: any) => {
        console.log(data);
        alert(data.message);
      }
    );

  }

  //for uploading technical specification starts
  uploadDocument() {
    let input = new FormData();
    input.append('avatar', this.form.get('avatar').value);
    input.append('documentType', 'TechnicalSpecs');
    input.append('module', 'Enquiry');
    input.append('applicationNumber', this.enquiryHeader.enquiryNo);

    this.enlistmentServices.UploadVendorDocument(input).subscribe(
      (data: any) => {
        if (data == true) {
          this.getVendorDocs();
        }
        else {

        }
      }
    );

  }

  getVendorDocs() {
    let inputs = new FormData();
    inputs.append('applicationNumber', this.enquiryHeader.enquiryNo);
    this.enlistmentServices.GetVendorDocs(inputs).subscribe(
      (data: any) => {
        this.vendorDocs = data;
        console.log(this.vendorDocs);
      }
    );
  }

  removeDoc = function (id) {
    this.enlistmentServices.removeVendorDocs(id).subscribe(
      (data: any) => {
        if (data == true) {
          this.getVendorDocs();
        }
        else {

        }
      }
    );
  }

  onFileChange(event) {
    //alert("selected");
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      this.form.get('avatar').setValue(file);

      console.log(this.form.get('avatar').value);
    }
  }

  //for uploading technical specifications ends

}
